export const defaultSinglePathData = {
  title: '',
  intro: '',
  banner: '',
  taskNo: 0,
  rooms: 0,
  description: '',
  summary: '',
  difficulty: 'easy',
  modules: [],
  isRetired: false,
  alternativePath: {
    _id: '',
    code: '',
    title: '',
    summary: '',
    difficulty: '',
    image: '',
  },
};
